import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Offerte, OfferteInkoop, OfferteObject } from '../model/offerte';
import { MatGridTileHeaderCssMatStyler } from '@angular/material/grid-list';
import { CommonService } from './common.service';
const { protocol, hostname, port } = window.location;

@Injectable({
  providedIn: 'root'
})
export class OfferteService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  private objecten: Array<OfferteObject> = null;

  baseURl: string = "http://localhost:3000/dev/";
  //baseURL = new URL('dev/', window.location.origin)

  constructor(private http: HttpClient, private common: CommonService) {
    this.baseURl = environment.url;
  }




  getObjecten():  Observable<Array<OfferteObject>> {
    const me = this;
    if (this.objecten != null ) {
        return new Observable<any>( (observer) => {
            observer.next(me.objecten);
            observer.complete();
        } );
    }
    const params = new HttpParams()
    .set('test', '' + 0)
    return new Observable<any>( (observer) => {
      this.http.get(this.baseURl +  "offerte/objecten",{params}).pipe(
          tap(_ => this.log('fetched offerte/objecten')),
          tap(e => { this.common.checkAndReportErrors(e)}),
          catchError(this.handleError<any>('getList', []))
          ).subscribe(data => {
            me.objecten = data;
            observer.next(me.objecten);
            observer.complete();
        });
      });
  }


  getOfferte(id : number) : Observable<Offerte> {
    return this.http.get(this.baseURl +  "offerte/" + id).pipe(
      tap(_ => this.log('fetched offerteobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getOfferte', []))
    );
  }

  getOfferteNr(offerteNr : number) : Observable<Offerte> {
    return this.http.get(this.baseURl +  "offerte/nr/" + offerteNr).pipe(
      tap(_ => this.log('fetched offerteobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getOfferte', []))
    );
  }

  saveOfferte(id: Number, offerte: Offerte) {
    return this.http.put(this.baseURl +  "offerte/" + id ,offerte, this.httpOptions).pipe(
      tap(_ => this.log('offerte saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveOfferte', []))
    );
  }

  postOfferte(offerte: Offerte) {
    return this.http.post(this.baseURl +  "offerte" ,offerte, this.httpOptions).pipe(
      tap(_ => this.log('offerte added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postOfferte', []))
    );
  }


  getOfferteInkoop(offerteid : number) : Observable<Array<OfferteInkoop>> {
    return this.http.get(this.baseURl +  "offerte/OfferteInkoop/" + offerteid).pipe(
      tap(_ => this.log('fetched getOfferteInkoop')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getOfferteInkoop', []))
    );
  }




  saveOfferteInkoop(id: Number, object: OfferteInkoop) {
    return this.http.put(this.baseURl +  "offerte/OfferteInkoop/" + id ,object, this.httpOptions).pipe(
      tap(_ => this.log('object saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveObject', []))
    );
  }

  postOfferteInkoop(data: OfferteInkoop) :Observable<any> {
    return this.http.post(this.baseURl +  "offerte/OfferteInkoop/" ,data, this.httpOptions).pipe(
      tap(_ => this.log('object added')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('postObject', []))
    );
  }

  deleteOfferteInkoop(id: number)  {
    return this.http.delete(this.baseURl +  "offerte/OfferteInkoop/" + id ,this.httpOptions).pipe(
      tap(_ => this.log('object saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveObject', []))
    );
  }


  postRapport(offerteid: number) {
    return this.http.post(this.baseURl +  "offerte/rapport/", {offerteid:offerteid},this.httpOptions).pipe(
      tap(_ => this.log('postRapport')),
      catchError(this.handleError<any>('postRapport', []))
    );
  }


  getWordRApport(offerteid: number)  : Observable<any> {
    let url = environment.url; "http://localhost:3000/"
    if (environment.production) {
      url = "https://i2szmfzy82.execute-api.eu-central-1.amazonaws.com/dev/";
    }
    
    return this.http.get(url +  "rapport/offerte/nl/" + offerteid).pipe(
      tap(_ => this.log('getWordRApport')),
      catchError(this.handleError<any>('getWordRApport', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  private log(message: string) {
    console.log(`OfferteService: ${message}`);
  }




}
